export default {
  API_URL: 'https://ithaca-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://ithacasandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
